import SquidGames from "./squid_games_404_bg.jpg";

export const DEFAULT_404 = {
  title: null,
  body: {
    json: null,
    __typename: "ContentType404PageBody",
  },
  background: {
    url: SquidGames,
    contentType: "image/jpeg",
  },
  ctaText: null,
};
